export default __webpack_public_path__ + "static/media/GardenImageMobile.d1c4226c.svg";